import React, { useContext } from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import SwitchTitleDescription from "../common/SwitchTitleDescription";
import GraphConfigFormContext from "@/store/contexts/GraphConfigFormContext";

interface LegendConfigProps {}

const positions = ["top", "right", "bottom", "left"] as const;

const LegendConfig: React.FC<LegendConfigProps> = ({}) => {
  const { config, setConfig } = useContext(GraphConfigFormContext);
  
  if (!config) return null;
  
  const legend = config.graph_options.legend;
  
  const onChange = (updatedLegend: typeof legend) => {
    setConfig({
      ...config,
      graph_options: {
        ...config.graph_options,
        legend: updatedLegend,
      },
    });
  };
  return (
    <div className="flex flex-col gap-4">
      <SwitchTitleDescription
        title="Show Legend"
        description="Show Legend"
        value={legend.show}
        onChange={(checked: boolean) => onChange({ ...legend, show: checked })}
      />
      <SwitchTitleDescription
        title="Clickable"
        description="Clickable"
        value={legend.clickable}
        onChange={(checked: boolean) =>
          onChange({ ...legend, clickable: checked })
        }
      />
      <div className="flex flex-row items-center justify-between w-full gap-1">
        <Label>Position</Label>
        <Select
          value={legend.position}
          onValueChange={(value) =>
            onChange({ ...legend, position: value as typeof legend.position })
          }
        >
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="Select position" />
          </SelectTrigger>
          <SelectContent>
            {positions.map((pos) => (
              <SelectItem key={pos} value={pos}>
                {pos.charAt(0).toUpperCase() + pos.slice(1)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default LegendConfig;
